import { useState, useEffect, useMemo } from 'react';
import { ticketsData, generateQuiz } from '../data/quizzes/land_military_rangs/ticketsData.js';
import '../styles/TicketsQuiz.css';

export default function TicketsQuiz() {
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  // Хранит ответы пользователя: { [indexВопроса]: answerId }
  const [userAnswers, setUserAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [showAllRangs, setShowAllRangs] = useState(false);

  // Инициализация квиза
  useEffect(() => {
    if (ticketsData.length < 3) {
      console.warn('Для работы квиза нужно минимум 3 билета!');
      return;
    }
    setQuestions(generateQuiz(ticketsData));
  }, []);

  // Подсчёт результатов
  const score = questions.reduce((acc, q, idx) => {
    const ans = userAnswers[idx];
    if (!ans) return acc;
    const selected = q.answers.find(a => a.id === ans.answerId);
    return acc + (selected?.isCorrect ? 1 : 0);
  }, 0);


  if (questions.length === 0) return <div className="quiz-loader">Загрузка билетов...</div>;

  const currentQ = questions[currentIndex];
  const currentAnswer = userAnswers[currentIndex];
  const isAnswered = currentAnswer !== undefined;
 
  const handleAnswerClick = (answer) => {
    if (isAnswered) return; // Блокируем повторный выбор
    setUserAnswers(prev => ({ ...prev, [currentIndex]: { answerId: answer.id } }));

    if (answer.isCorrect) {
      setTimeout(() => {
        setShowHint(false); // ✅ Скрываем подсказку при автопереходе
        if (currentIndex < questions.length - 1) {
          setCurrentIndex(prev => prev + 1);
        } else {
          setShowResults(true);
        }
      }, 350); // Задержка нужна, чтобы React успел отрисовать зелёную подсветку
    }  };

  const handleNext = () => {
    if (!isAnswered) return; // Не пускаем дальше, пока не ответили
    setShowHint(false);
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(prev => prev + 1);
    } else {
      setShowResults(true);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(prev => prev - 1);
    setShowHint(false);
  };

  const handleRestart = () => {
    setUserAnswers({});
    setCurrentIndex(0);
    setShowResults(false);
    setShowHint(false);
    setShowAllRangs(false);
    setQuestions(generateQuiz(ticketsData)); 
  };

  const toggleHint = () => {
    setShowHint(!showHint);
  };

  const toggleAllRangs = () => {
    setShowAllRangs(!showAllRangs);
  };

  // --- ЭКРАН РЕЗУЛЬТАТОВ ---
  if (showResults) {
    const percent = Math.round((score / questions.length) * 100);
    return (
      <div className="quiz-container results">
        <h2>Тест завершён!</h2>
        <div className="score-circle">
          <span>{score}/{questions.length}</span>
          <p>{percent}%</p>
        </div>
        <button className="btn restart" onClick={handleRestart}>Пройти заново</button>
      </div>
    );
  }

  // --- ЭКРАН ВОПРОСА ---
  return (
    <div className="quiz-container">
      <div className="quiz-header">
        <span className="progress">Вопрос {currentIndex + 1} из {questions.length}</span>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${((currentIndex + 1) / questions.length) * 100}%` }} />
        </div>
      </div>

      <div className="ticket-card">
        <img src={currentQ.image} alt="Билет" className="ticket-image" />
        <h3 className="question-text">{currentQ.question}</h3>
        
        <button className="btn hint-btn" onClick={toggleHint}>
          {showHint ? 'Скрыть подсказку' : 'Подсказка'}
        </button>
        
        {showHint && (
          <div className="hint-box">
            <strong> Запомни:</strong>
            <p>{currentQ.hint}</p>
          </div>
        )}

        <div className="answers-grid">
          {currentQ.answers.map((answer) => {
            const isSelected = currentAnswer?.answerId === answer.id;
            
            let btnClass = 'answer-btn';
            if (isAnswered) {
              if (answer.isCorrect) btnClass += ' correct';
              else if (isSelected) btnClass += ' wrong';
            }

            return (
              <button
                key={answer.id}
                className={btnClass}
                onClick={() => handleAnswerClick(answer)}
                disabled={isAnswered}
              >
                {answer.text}
              </button>
            );
          })}
        </div>
      </div>

      <div className="quiz-navigation">
        <button 
          className="btn prev" 
          onClick={handlePrev} 
          disabled={currentIndex === 0}
        >
          ← Назад
        </button>
        <button 
          className="btn next" 
          onClick={handleNext} 
          disabled={!isAnswered}
        >
          {currentIndex === questions.length - 1 ? 'Завершить →' : 'Далее →'}
        </button>
      </div>

      <div className='hint-box'>
        <button
          className='btn hint-btn'
          onClick={toggleAllRangs}
        > {showAllRangs ? 'Показать все звания' : 'Скрыть все звания'}
        </button>

      </div>

      {showAllRangs && (
        <div className='allrangs-container'>
          <img src='/tickets/land_miliraty_rangs/all_rangs.png' alt="All Rangs" className="allrangs-image" />
        </div>
      )}


    </div>
);
}
